import React, { useState } from "react";
import { useNavigate } from "react-router";
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useWindowDimensions } from "@lib-shared/hooks";
import { BusinessPage } from "core/constants";
import { Feature, isEnabled } from "core/features";
import UrlUtils from "core/lib/url-utils";

type ActionButtonsProps = {
    displayClearErrorModal: any,
    width: number
}

const ActionButtons = (props: ActionButtonsProps) => {
    const noSwipeCssName = "no-swipe";
    const swipeableBreakpoint = 768;
    const dimensions = useWindowDimensions();
    const navigate = useNavigate();
    const { displayClearErrorModal, width } = props;

    const [swiperInstance, setSwiper] = useState<any>(undefined);

    const gotoPage = (page: string) => {
        navigate(page);
    }

    // const functionNotAvailable = () => {
    //     ModalAlert.alert("Not Available", "This functionality is not available yet");
    // }

    const contactUrl = `${window.location.origin}/business/${UrlUtils.getLanguageCode()}/dstv-business-packages/contact`;
    //business/en-za/dstv-business-packages/contact

    const show = {
        fixError: isEnabled(Feature.dashboard_clearError),
        statements: isEnabled(Feature.dashboard_statements),
        users: isEnabled(Feature.users),
        queries: isEnabled(Feature.support)
    }

    const allowTouchMove = dimensions.width < swipeableBreakpoint;

    if (allowTouchMove === true && swiperInstance && swiperInstance.pagination?.bullets?.length < 3) {
        //If the initial screen size requires no swiper & then you resize
        //to mobile, the pagination module doesn't update. I have tried
        //swiper.update() & pagination methods but nothing works hence
        //the refresh. 

        //This situation would mainly occur during resolution/device testing.

        //Timeout in case you start with phone resolution & then expand. 
        //Gives time for update to occur normally - i.e. this isn't bugged.

        setTimeout(() => {
            if (swiperInstance.pagination?.bullets?.length < 3) {
                window.location.reload();
            }
        }, 500);
    }

    const cssName = `swiper-actions${allowTouchMove ? "" : " no-swipe"}`;

    return <Swiper
        id="actions-swiper"
        spaceBetween={15}
        slidesPerView="auto"
        grid={{ rows: 1 }}
        width={width}
        className={cssName}
        pagination={{ clickable: true, enabled: allowTouchMove }}
        modules={[Pagination]}
        noSwipingClass={noSwipeCssName}
        //allowTouchMove={allowTouchMove}
        enabled={allowTouchMove}
        onSwiper={(swiper: any) => {
            // console.log("on", swiper);
            setSwiper(swiper);
        }}>
        {show.fixError && <SwiperSlide className="action" onClick={() => displayClearErrorModal()} title="Fix Error">
            <i className="icon icon-maintenance"></i>
            Fix Error
        </SwiperSlide>}
        {show.statements && <SwiperSlide className="action" onClick={() => gotoPage(BusinessPage.statementsAndInvoices)} title="Statements & Invoices">
            <i className="icon icon-letter"></i>
            Statements &amp;<br />
            Invoices
        </SwiperSlide>}
        {show.users && <SwiperSlide className="action" onClick={() => gotoPage(BusinessPage.users)} title="Manage Users">
            <i className="icon icon-manage-profile"></i>
            Manage Users
        </SwiperSlide>}
        {/* {can.changePackage && <SwiperSlide className="action" title="Manage Packages" onClick={() => functionNotAvailable()}>
            <i className="icon icon-filter"></i>
            Manage Packages
        </SwiperSlide>} */}
        {show.queries && <SwiperSlide className="action" onClick={() => gotoPage(BusinessPage.support)} title="Queries">
            <i className="icon icon-help"></i>
            Queries
        </SwiperSlide>}
        {/* <SwiperSlide className="action" title="Live Chat" onClick={() => functionNotAvailable()}>
            <i className="icon icon-imi-live-chat"></i>
            Live Chat
        </SwiperSlide> */}

        <SwiperSlide className="action" onClick={() => window.location.href = contactUrl} title="Contact Us">
            <i className="icon icon-contact"></i>
            Contact Us
        </SwiperSlide>
    </Swiper>
}

export default ActionButtons;
